import { IOnInit } from "angular";

export class ContractInstanceFilesComponentController implements IOnInit {
  static $inject = [];
  constructor() {}

  $onInit(): void {}
}
